import type { Vector3 } from "three";
import type { SugarModel } from "../../loader/SugarModel";
import {
  DragConstraintPipeline,
  type DragSessionPort,
} from "./DragSessionPort";

/**
 * Shared scene-move session over a constraint pipeline.
 * Products supply the pipeline (wall/joint vs peer/joint).
 */
export function createConstrainedDragSession(
  model: SugarModel,
  pipeline: DragConstraintPipeline,
  options?: {
    /** Skip pipeline for this model (e.g. whole configurator root). */
    bypass?: (model: SugarModel) => boolean;
    onBypassBegin?: () => void;
    onBypassCancel?: () => void;
  },
): DragSessionPort<void, Vector3, void> {
  const bypass = options?.bypass;
  return {
    begin() {
      if (bypass?.(model)) {
        options?.onBypassBegin?.();
        return;
      }
      pipeline.onDragStart(model);
    },
    move(position: Vector3) {
      if (bypass?.(model)) {
        model.position.copy(position);
        return;
      }
      model.position.copy(pipeline.resolve(model, position));
    },
    commit() {
      if (!bypass?.(model)) pipeline.onDragEnd(model);
    },
    cancel() {
      if (bypass?.(model)) {
        options?.onBypassCancel?.();
        return;
      }
      pipeline.onDragEnd(model);
    },
  };
}
